/* istanbul ignore file */
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const ProvideStore = () => {
  const store = useSelector((state) => state?.global?.store);

  if (!store.id) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default ProvideStore;
